export default __webpack_public_path__ + "assets/images/aistudio/empty_state/714fe03caa9dea9d467add6ca69bd847.png";